import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addProcess,
  getProcesss,
  getProcess,
  editProcess,
  deleteProcess,
  getAllProcesss,
} from '../../store/actions/process_action';
import _debounce from 'lodash/debounce';
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllProcesss = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.process);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteProcess(deleteEntry));
    }
    allQuery();
  }, [deleteEntry]);

  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getProcesss({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    if (pageNumber) {
      dispatch(
        getProcesss({
          pageNumber,
        })
      );
    }
  }, [pageNumber]);

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleProcess = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.process);
  useEffect(() => {
    dispatch(getProcess(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateProcess = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.process);
  const addData = async (data) => {
    await dispatch(addProcess(data));
  };
  return [data, addData];
};
export const useUpdateProcess = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.process);
  const updateData = async (id, data) => {
    await dispatch(editProcess(id, data));
  };
  return [updateData];
};

export const useSelectAllProcess = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState('');
  const [value, setValue] = useState('');
  const data = useSelector((state) => state.process);
  useEffect(() => {
    dispatch(getAllProcesss({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

  return [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ];
};
